<script lang="ts">
  import type { Dropdown } from '$lib/components/website/dropdownFilters/types';
  import Checkbox from '../Checkbox.svelte';
  import { clickOutside } from '$lib/helpers/clickOutside';

  export let dropdownDetails: Dropdown;
  export let selectedValues: string[];
  export let handleSelect: (...args: any[]) => void = () => {};

  export let theme: 'pink' | 'default' = 'default';
  export let customClass = '';

  let open = false;
  $: selectedItemsLabels = selectedValues?.length ? selectedValues.join(', ') : 'All';

  const widthClass = 'w-full';
</script>

<div class="relative inline-block text-left focus:shadow-primary-shadow {customClass}">
  <button
    type="button"
    data-dropdown-trigger="click"
    class="inline-flex focus:outline-none {widthClass} justify-between gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 border border-gray-300 focus:border-primary-500 focus:ring-4 focus:ring-primary-shadow focus:ring-offset"
    use:clickOutside
    on:outsideclick|stopPropagation|preventDefault={() => {
      open = false;
    }}
    on:click={() => {
      open = !open;
    }}
    aria-expanded="true"
    aria-haspopup="true"
  >
    {selectedItemsLabels}
    <svg
      class="-mr-1 h-5 w-5 text-gray-400"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
        clip-rule="evenodd"
      />
    </svg>
  </button>

  {#if open}
    <div
      class="absolute right-0 left-0 z-10 mt-1 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      tabindex="-1"
    >
      <ul class="py-1 {widthClass} max-h-64 overflow-y-scroll" role="none">
        {#each dropdownDetails.options as dropdownOption, index}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <li
            class="text-gray-700 px-4 py-2 text-sm flex hover:pointer hover:bg-gray-50"
            role="menuitem"
            tabindex="-1"
            id={`menu-item-${index}`}
            on:click|stopPropagation|preventDefault={() =>
              handleSelect(
                dropdownDetails.id,
                dropdownOption.value,
                dropdownDetails.canSelectMultiple,
              )}
          >
            <Checkbox {theme} checked={selectedValues.includes(dropdownOption.value)} />
            <span>{dropdownOption.label}</span>
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>
